export default __webpack_public_path__ + "static/media/64.48f31a24.jpg";